import React, { useEffect, useState, useContext } from 'react';
import { AuthContext, } from '../../contexts/auth'
import { useLocation, /*useNavigate*/ } from 'react-router-dom';
import { api, getSchoolsData, loginWithSchool, NameSchool } from '../../Api';
import { loadSchoolAssessmentInfo } from '../../utils/sessionSchool';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: #f5f5f5;
    padding: 20px;
`;

const Title = styled.h1`
    font-size: 2rem;
    color: #333;
    margin-bottom: 10px;
    text-align: center;

    @media (max-width: 768px) {
        font-size: 1.5rem;
    }
`;

const SubTitle = styled.h2`
    font-size: 1.2rem;
    color: #666;
    margin-bottom: 20px;
    text-align: center;

    @media (max-width: 768px) {
        font-size: 1rem;
    }
`;

const SchoolList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    max-width: 1000px;

    @media (max-width: 768px) {
        max-width: 90%;
    }
`;

const SchoolButton = styled.button`
    padding: 15px 20px;
    font-size: 1rem;
    font-weight: bold;
    color: #fff;
    background-color: #4caf50;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
        background-color: #45a049;
    }

    @media (max-width: 768px) {
        padding: 12px 16px;
        font-size: 0.9rem;
    }
`;

const SchoolSelection = () => {
    //const navigate = useNavigate();
    const location = useLocation();
    const { schools, cpf } = location.state || {};
    const [schoolData, setSchoolData] = useState([]);
    const [selecting, setSelecting] = useState(false);
    const { loginEmployee } = useContext(AuthContext)

    useEffect(() => {
        const fetchSchoolData = async () => {
            if (schools && schools.length > 0) {
                try {
                    const response = await getSchoolsData(schools.map(s => s.id));
                    setSchoolData(response.data.data);
                } catch (error) {
                    console.error("Erro ao buscar dados das escolas:", error);
                }
            }
        };

        fetchSchoolData();
    }, [schools]);

    const handleSchoolSelect = async (schoolId) => {
        if (selecting) return;          // evita clique duplo enquanto processa
        setSelecting(true);

        try {
            const response = await loginWithSchool(cpf, schoolId)

            if (!response) {
                setSelecting(false);
                return;
            }

            const data = response.data

            // ── Valida os campos essenciais antes de gravar qualquer coisa ───
            if (!data.token || !data.id || !data.type || !data.id_school) {
                console.error('Seleção de escola incompleta. Campos ausentes:', {
                    token: data.token, id: data.id, type: data.type, id_school: data.id_school
                })
                setSelecting(false);
                return;
            }

            // ── Token no header ANTES das chamadas protegidas ────────────────
            // (NameSchool, getSchool e getAssessmentRegime exigem token)
            api.defaults.headers.Authorization = `Bearer ${data.token}`

            // ── Nome da escola protegido: se falhar, o fluxo segue ───────────
            let nomeEscola = ''
            try {
                const nameSchool = await NameSchool(data.id_school)
                nomeEscola = nameSchool?.data?.data ?? ''
            } catch (err) {
                console.error('Falha ao buscar nome da escola:', err)
            }

            // ── É AQUI que format+regime são gravados para quem tem várias ───
            // escolas: só agora existe um id_school definido.
            await loadSchoolAssessmentInfo(data.id_school)

            // ── Grava tudo de uma vez (sem await no meio) ────────────────────
            localStorage.setItem('lastLogin', Date.now())
            sessionStorage.setItem("School", nomeEscola)
            localStorage.setItem("Id_employee", JSON.stringify(data.id))
            sessionStorage.setItem("cpf", data.CPF)
            sessionStorage.setItem("name", data.name)
            localStorage.setItem("name", data.name)
            localStorage.setItem("type", data.type)
            localStorage.setItem("position_at_school", data.position_at_school)
            sessionStorage.setItem("id-school", JSON.stringify(data.id_school))
            sessionStorage.setItem("id_matter", data.id_matter)
            sessionStorage.setItem("id_class", data.id_class)
            sessionStorage.setItem("id_reporter_cardid_class", data.id_reporter_card)
            localStorage.setItem("token", data.token)
            sessionStorage.setItem("token", data.token)
            // (Authorization já foi setado acima)

            // ── Verifica que o essencial ficou gravado ───────────────────────
            const gravou =
                sessionStorage.getItem('token') &&
                sessionStorage.getItem('id-school') &&
                localStorage.getItem('Id_employee') &&
                localStorage.getItem('type')

            if (!gravou) {
                console.error('Falha ao preparar a sessão após seleção de escola.')
                setSelecting(false);
                return;
            }

            // ── Atualiza contexto e navega (sem a corrida navigate x reload) ─
            loginEmployee(data.CPF)
            window.location.assign('/home/employee')

        } catch (err) {
            console.error('Erro ao selecionar escola:', err)
            setSelecting(false);
        }
    };

    return (
        <Container>
            <Title>Escolha uma Escola</Title>
            <SubTitle>Qual escola deseja acessar?</SubTitle>
            <SchoolList>
                {schoolData.length > 0 ? (
                    schoolData.map((school) => (
                        <SchoolButton
                            key={school.id}
                            onClick={() => handleSchoolSelect(school.id)}
                            disabled={selecting}
                        >
                            {school.name}
                        </SchoolButton>
                    ))
                ) : (
                    <p>Nenhuma escola disponível.</p>
                )}
            </SchoolList>
        </Container>
    );
};

export default SchoolSelection;